import React, {useCallback, useState} from 'react';
import Calculator from './components/Calculator';
import FormulaExplorer from './components/FormulaExplorer';
import BodyMap from './components/BodyMap';
import LearningTools from './components/LearningTools';
import FormulaLibrary from './components/FormulaLibrary';
import HeroVisual from './components/HeroVisual';
import Editorial from './components/Editorial';
import {calculate} from './lib/calculations';
import './App.css';

export default function App() {
  const [area, setArea] = useState(calculate(170, 70).Mosteller);
  const [metric, setMetric] = useState({height: 170, weight: 70});
  const [formula, setFormula] = useState('Mosteller');
  const [formulaResults, setFormulaResults] = useState(calculate(170, 70));

  const handleResult = useCallback((nextArea, nextMetric, nextFormula, nextResults) => {
    setArea(nextArea);
    setMetric(nextMetric);
    setFormula(nextFormula);
    setFormulaResults(nextResults);
  }, []);

  return (
    <div className="site">
      <header className="topbar">
        <div className="container nav">
          <a href="#inicio" aria-label="Superfície Corporal, voltar ao início" className="brand logo"><svg viewBox="0 0 32 32" width="28" height="28" aria-hidden="true" focusable="false"><circle cx="16" cy="6" r="4" fill="currentColor"/><path d="M11 12.5C8.5 13 7 14.5 6.5 17L5 24.5C4.8 25.5 6.2 26 6.6 25L8.5 19.5L9 28C9 29.2 10.2 29.5 10.8 28.6L13.2 21.5H18.8L21.2 28.6C21.8 29.5 23 29.2 23 28L23.5 19.5L25.4 25C25.8 26 27.2 25.5 27 24.5L25.5 17C25 14.5 23.5 13 21 12.5Z" fill="var(--logo-accent)"/></svg><span>Superfície corporal</span></a>
          <nav aria-label="Navegação principal">
            <a href="#calculadora">Calculadora</a>
            <a href="#mapa">Mapa corporal</a>
            <a href="#biblioteca">Fórmulas</a>
            <a href="#entenda">Entenda</a>
          </nav>
        </div>
      </header>

      <main id="inicio" className="container">
        <section className="hero" aria-labelledby="page-title">
          <div className="hero-copy">
            <p className="eyebrow">Uma estimativa clara, dez formas de calcular</p>
            <h1 id="page-title">Calculadora de superfície corporal <span>(Mosteller)</span></h1>
            <p className="hero-intro">Informe altura e peso, escolha uma fórmula e veja como diferentes equações estimam a superfície corporal.</p>
            <Calculator onResult={handleResult} />
          </div>
          <HeroVisual metric={metric} area={area} formula={formula} results={formulaResults} />
        </section>

        <aside className="notice" role="note">
          <strong>Uma estimativa não é uma prescrição.</strong>
          <p>A superfície corporal é uma estimativa. Esta calculadora não define doses de medicamentos nem de quimioterapia; a prescrição e o cálculo final cabem ao profissional responsável.</p>
        </aside>

        <div className="tools-intro">
          <p className="eyebrow">Aprenda explorando</p>
          <h2>Como a altura e o peso mudam o resultado?</h2>
          <p>Altere as medidas para acompanhar a conta e comparar três estimativas em tempo real.</p>
        </div>

        <FormulaExplorer />
        <BodyMap area={area} metric={metric} />
        <LearningTools area={area} />
        <FormulaLibrary />
        <Editorial />
      </main>

      <footer>
        <div className="container footer-inner">
          <div>
            <strong>superfíciecorporal.com.br</strong>
            <p>Informação educativa com clareza e responsabilidade.</p>
          </div>
          <nav aria-label="Guias"><a href="/superficie-corporal-queimada/">Superfície corporal queimada: regra dos nove, Lund-Browder e Parkland</a><a href="/tfg-indexada-superficie-corporal/">TFG indexada e superfície corporal</a></nav>
          <a href="#inicio">Voltar ao topo ↑</a>
        </div>
      </footer>
    </div>
  );
}
